export default __webpack_public_path__ + "static/media/will.7c21b6c4.jpg";